import { render } from "./CasualPayrollPayouts.vue?vue&type=template&id=7dec6769"
import script from "./CasualPayrollPayouts.vue?vue&type=script&lang=js"
export * from "./CasualPayrollPayouts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__